import React, { useEffect, useState } from "react";
import libse_photo from "../../components/images/usa/LibseHaile.jpg";
import aster_photo from "../../components/images/usa/AsterBelay.jpg";

import "./announcements.css";

/*
 * Time-sensitive announcements.
 * Each shows from its startDate (inclusive) until its endDate (exclusive), in the visitor's local time.
 * If an announcement has no dates of its own, DEFAULT_START / DEFAULT_END are used.
 * Note: JavaScript months are 0-based (0 = January, 9 = October, 10 = November).
 */
const DEFAULT_START = new Date(2026, 9, 17); // Oct 13, 2026
const DEFAULT_END = new Date(2026, 10, 17); // Nov 13, 2026 (one month)

// One entry per announcement. "years", "startDate" and "endDate" are optional.
// "message" is a list of paragraphs.
const announcements = [
  {
    name: "Libse Haile",
    photo: libse_photo,
    years: "1947 - 2026",
    message: [
      "Dear Rediet for Tegaru Women Members,",
      "We are deeply sorry for the loss of our member Libse Haile, and we express our condolences to her family and friends.",
      "May her soul rest in peace.",
    ],
    rediet_message: [
      "መዘክሮ ወይዘሮ ልብሰይ ሃይለ ኣብ ረዲኤት ንተጋሩ ደቂኣንስትዮን",
      "ልብሰ ሃይለ ካብቶም ንትካልና ረዲኤት ንተጋሩ ደቂ ኣንስትዮ ዝመስረቱ ሓንቲ ግድስቲ ሓፍትና እያ:: ካብ ምምስራት ትካልና ጀሚራ ኣዴታት ትግራይ ክሕገዛን እግሪ ንኽተኽላን ክሳዕታ ሕልፈተ ሂወታ ዘይሕለል ፃዕሪ ዝገበረት : ካብታ ትረኽባ ናይ ጡረታ ገንዘባ ካብ ዝግመት ንላዕሊ ዘወፈየት ; ትካልና ክጠናኸር : ኣባላት ንኽበዝሑን:ወፈያ ንኽተኣኻኸብን ; ናይ ኣባልነት ክፍሊት $ 10 ናይ ሓንቲ ምዓልቲ ቁርሲ ምግዳፍ ናይ ሓንቲ ኣዶ ትግራይ ሂወት የድሕን እናበለት ቤተሰባ ኣባላት እናገበረት ኣብ ቤተሰባ ዘለው ኣናእሽተይ ቆልዑ ከይተረፉ ካብ ዝረኽብዎ ውህብቶ ከወፉይ እናተባብዐት ምሓዙታ እናተሓባበረት : ባዕላ ከይተረፈ ገንዘብ ኣኻኺባ እናምፅአት : ኣብ ዝሃለወት ትሃሉ ንኣባላት ቦርድ እናደወለት ትካልና ከመይ ኣላ ታይ ክሕግዝ ኣጆና ትካልና ክትጥንክርን ዋልታ ኣዴታት ትግራይ ክትከውን እያ ትብል ባዓልቲ ብሩህ ተስፋ ናይ ተግባር ሰብ ልብሰይ ብሂወት ተፈልያትና :ብሽም እተን ከይጠምያ እትሓልየለን ኣዴታት ትግራይን ትካልናን መንግሰተ ሰማያት የዋርስኪ እናበልና መሪር ሓዘና ንገልፅ::",
    ],
  },
  {
    name: "Aster Belay",
    photo: aster_photo,
    years: "1962 - 2026",
    message: [
      "Dear Rediet for Tegaru Women Members,",
      "We are deeply sorry for the loss of our member Aster Belay, and we express our condolences to her family and friends.",
      "May her soul rest in peace.",
    ],
  },
];

// Shown once, below all active announcements, with a heading naming everyone it applies to.
// Set to "" to hide.
const closingNote =
  "Although they passed away some time ago, technical problems prevented us from sharing these announcements on our website sooner. We sincerely apologize for the delay.";

const joinNames = (names) =>
  names.length <= 1
    ? names.join("")
    : `${names.slice(0, -1).join(", ")} and ${names[names.length - 1]}`;

const isActive = (a, now = new Date()) =>
  now >= (a.startDate || DEFAULT_START) && now < (a.endDate || DEFAULT_END);

const getActive = () => announcements.filter((a) => isActive(a));

const Announcements = () => {
  const [active, setActive] = useState(getActive());

  // Re-check hourly so a page left open hides announcements once their period ends.
  // (A single setTimeout can't be used: delays over ~24.8 days overflow and fire immediately.)
  useEffect(() => {
    const id = setInterval(() => setActive(getActive()), 60 * 60 * 1000);
    return () => clearInterval(id);
  }, []);

  if (active.length === 0) return null;

  return (
    <div className="announcements">
      {active.map((a) => (
        <section
          className="announcement condolence"
          aria-label={`In memory of ${a.name}`}
          key={a.name}
        >
          <h3 className="announcement-title">In Loving Memory</h3>

          <div className="announcement-photos">
            <figure className="announcement-person">
              <div className="announcement-frame">
                <img
                  src={a.photo}
                  alt={`In memory of ${a.name}`}
                  className="announcement-photo"
                />
              </div>
              <figcaption>
                <span className="announcement-name">{a.name}</span>
                {a.years && (
                  <span className="announcement-years">{a.years}</span>
                )}
              </figcaption>
            </figure>
          </div>

          <div className="announcement-message">
            {a.message.map((paragraph, i) => (
              <p key={i}>{paragraph}</p>
            ))}
            {a.rediet_message && (
              <div className="announcement-message" lang="ti">
                {a.rediet_message.map((paragraph, i) => (
                  <p key={i}>{paragraph}</p>
                ))}
              </div>
            )}
          </div>
        </section>
      ))}

      {closingNote && (
        <aside
          className="announcement-note"
          aria-label="Note about these announcements"
        >
          <p className="announcement-note-heading">
            A note on the loss of our members{" "}
            {joinNames(active.map((a) => a.name))}
          </p>
          <p className="announcement-note-text">{closingNote}</p>
        </aside>
      )}
    </div>
  );
};

export default Announcements;
